export interface AssistantMessageLayout {
  container: string;
  bubble: string;
}

export function getAssistantMessageLayout(hasApplicationContent: boolean): AssistantMessageLayout {
  return {
    container: hasApplicationContent
      ? 'flex w-fit max-w-[calc(100%-2.75rem)] flex-col items-end'
      : 'flex w-fit max-w-[80%] flex-col items-end',
    bubble: 'w-fit max-w-full',
  };
}
